import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
const Icon = dynamic(() => import('../Icon/Icon'))
import { Constants } from '../../adapters/helpers/Constants'
import { redirectTo } from '../../adapters/helpers/Utils'
import { scrollIntoView } from '../../adapters/helpers/Scroll'
import classNames from 'classnames'

const DropDownSelector = ({ options, selectedOption, handleOptionClick, anchorId }) => {
    const [isOpen, setIsOpen] = useState(false)
    const dropDownRef = useRef()

    useEffect(() => {
        if (window?.location?.hash === `#${anchorId}` && dropDownRef?.current) {
            let timeout = null
            window.setTimeout(() => {
                timeout = scrollIntoView(dropDownRef.current, { behavior: 'smooth', block: 'nearest' })
            }, 250)

            return () => {
                clearTimeout(timeout)
            }
        }
    }, [])

    const selectOption = (index, url) => {
        if (url) {
            redirectTo(url)
        } else {
            handleOptionClick(index)
            setIsOpen(false)
        }
    }

    const toggleDropDown = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div ref={dropDownRef} className={`select-component ${isOpen ? 'open' : ''}`}>
            <div tabIndex={0} className='select-component-header' role='button' onKeyPress={toggleDropDown} onClick={toggleDropDown}>
                <span>{options[selectedOption]?.fields?.label}</span>
                <Icon name={Constants.chevronDown} />
            </div>
            {isOpen && (
                <ul className='select-component-options'>
                    {options.map((option, index) => (
                        <li
                            key={index}
                            className={classNames(selectOption === index ? 'selected' : '', 'event_button_click')}
                            data-action-detail={option?.fields?.label}
                            onClick={() => selectOption(index, option?.fields?.tabPageUrl)}
                            role='presentation'
                            tabIndex={0}
                            onKeyPress={() => selectOption(index, option?.fields?.tabPageUrl)}
                        >
                            {option?.fields?.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

DropDownSelector.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
    selectedOption: PropTypes.number,
    handleOptionClick: PropTypes.func,
}

export default DropDownSelector
